// Cube Utility Functions for SolveSmarter

// Scramble Generation
const moves = ['R', 'L', 'U', 'D', 'F', 'B'];
const modifiers = ['', "'", '2'];

export function generateScramble(length = 20) {
  let scramble = [];
  let lastMove = '';
  let secondLastMove = '';

  for (let i = 0; i < length; i++) {
    let move;
    do {
      move = moves[Math.floor(Math.random() * moves.length)];
    } while (
      move === lastMove || 
      (move === secondLastMove && isOpposite(move, lastMove))
    );

    const modifier = modifiers[Math.floor(Math.random() * modifiers.length)];
    scramble.push(move + modifier);
    secondLastMove = lastMove;
    lastMove = move;
  }

  return scramble.join(' ');
}

function isOpposite(move1, move2) {
  const opposites = { 'R': 'L', 'L': 'R', 'U': 'D', 'D': 'U', 'F': 'B', 'B': 'F' };
  return opposites[move1] === move2;
}

// Cube State for Visualization
export class CubeState {
  constructor() {
    this.faces = {
      U: ['W','W','W','W','W','W','W','W','W'],
      D: ['Y','Y','Y','Y','Y','Y','Y','Y','Y'],
      F: ['G','G','G','G','G','G','G','G','G'],
      B: ['B','B','B','B','B','B','B','B','B'],
      R: ['R','R','R','R','R','R','R','R','R'],
      L: ['O','O','O','O','O','O','O','O','O']
    };
  }

  rotateFace(face, clockwise = true) {
    const f = this.faces[face];
    if (clockwise) {
      this.faces[face] = [f[6],f[3],f[0],f[7],f[4],f[1],f[8],f[5],f[2]];
    } else {
      this.faces[face] = [f[2],f[5],f[8],f[1],f[4],f[7],f[0],f[3],f[6]];
    }
  }

  applyMove(move) {
    const face = move[0].toUpperCase();
    const modifier = move.slice(1);
    const times = modifier === '2' ? 2 : 1;
    const clockwise = modifier !== "'";

    for (let i = 0; i < times; i++) {
      this.rotateFace(face, clockwise);
      this.rotateAdjacentEdges(face, clockwise);
    }
  }

  rotateAdjacentEdges(face, clockwise) {
    const { U, D, F, B, R, L } = this.faces;
    let temp;

    switch(face) {
      case 'U':
        if (clockwise) {
          temp = [F[0],F[1],F[2]];
          [F[0],F[1],F[2]] = [R[0],R[1],R[2]];
          [R[0],R[1],R[2]] = [B[0],B[1],B[2]];
          [B[0],B[1],B[2]] = [L[0],L[1],L[2]];
          [L[0],L[1],L[2]] = temp;
        } else {
          temp = [F[0],F[1],F[2]];
          [F[0],F[1],F[2]] = [L[0],L[1],L[2]];
          [L[0],L[1],L[2]] = [B[0],B[1],B[2]];
          [B[0],B[1],B[2]] = [R[0],R[1],R[2]];
          [R[0],R[1],R[2]] = temp;
        }
        break;
      case 'D':
        if (clockwise) {
          temp = [F[6],F[7],F[8]];
          [F[6],F[7],F[8]] = [L[6],L[7],L[8]];
          [L[6],L[7],L[8]] = [B[6],B[7],B[8]];
          [B[6],B[7],B[8]] = [R[6],R[7],R[8]];
          [R[6],R[7],R[8]] = temp;
        } else {
          temp = [F[6],F[7],F[8]];
          [F[6],F[7],F[8]] = [R[6],R[7],R[8]];
          [R[6],R[7],R[8]] = [B[6],B[7],B[8]];
          [B[6],B[7],B[8]] = [L[6],L[7],L[8]];
          [L[6],L[7],L[8]] = temp;
        }
        break;
      case 'F':
        if (clockwise) {
          temp = [U[6],U[7],U[8]];
          [U[6],U[7],U[8]] = [L[8],L[5],L[2]];
          [L[2],L[5],L[8]] = [D[2],D[1],D[0]];
          [D[0],D[1],D[2]] = [R[6],R[3],R[0]];
          [R[0],R[3],R[6]] = temp;
        } else {
          temp = [U[6],U[7],U[8]];
          [U[6],U[7],U[8]] = [R[0],R[3],R[6]];
          [R[0],R[3],R[6]] = [D[2],D[1],D[0]];
          [D[0],D[1],D[2]] = [L[6],L[3],L[0]];
          [L[2],L[5],L[8]] = temp;
        }
        break;
      case 'B':
        if (clockwise) {
          temp = [U[0],U[1],U[2]];
          [U[0],U[1],U[2]] = [R[2],R[5],R[8]];
          [R[2],R[5],R[8]] = [D[8],D[7],D[6]];
          [D[6],D[7],D[8]] = [L[0],L[3],L[6]];
          [L[0],L[3],L[6]] = [temp[2],temp[1],temp[0]];
        } else {
          temp = [U[0],U[1],U[2]];
          [U[0],U[1],U[2]] = [L[6],L[3],L[0]];
          [L[0],L[3],L[6]] = [D[6],D[7],D[8]];
          [D[6],D[7],D[8]] = [R[8],R[5],R[2]];
          [R[2],R[5],R[8]] = [temp[2],temp[1],temp[0]];
        }
        break;
      case 'R':
        if (clockwise) {
          temp = [U[2],U[5],U[8]];
          [U[2],U[5],U[8]] = [F[2],F[5],F[8]];
          [F[2],F[5],F[8]] = [D[2],D[5],D[8]];
          [D[2],D[5],D[8]] = [B[6],B[3],B[0]];
          [B[0],B[3],B[6]] = [temp[2],temp[1],temp[0]];
        } else {
          temp = [U[2],U[5],U[8]];
          [U[2],U[5],U[8]] = [B[6],B[3],B[0]];
          [B[0],B[3],B[6]] = [D[8],D[5],D[2]];
          [D[2],D[5],D[8]] = [F[2],F[5],F[8]];
          [F[2],F[5],F[8]] = temp;
        }
        break;
      case 'L':
        if (clockwise) {
          temp = [U[0],U[3],U[6]];
          [U[0],U[3],U[6]] = [B[8],B[5],B[2]];
          [B[2],B[5],B[8]] = [D[6],D[3],D[0]];
          [D[0],D[3],D[6]] = [F[0],F[3],F[6]];
          [F[0],F[3],F[6]] = temp;
        } else {
          temp = [U[0],U[3],U[6]];
          [U[0],U[3],U[6]] = [F[0],F[3],F[6]];
          [F[0],F[3],F[6]] = [D[0],D[3],D[6]];
          [D[0],D[3],D[6]] = [B[8],B[5],B[2]];
          [B[2],B[5],B[8]] = [temp[2],temp[1],temp[0]];
        }
        break;
    }
  }

  applyScramble(scramble) {
    const moves = scramble.split(' ').filter(m => m);
    moves.forEach(move => {
      // Handle wide moves and rotations
      const baseMove = move.replace(/[2']/g, '');
      if (['R','L','U','D','F','B'].includes(baseMove)) {
        this.applyMove(move);
      }
      // Skip M, E, S, x, y, z for now (simplified)
    });
  }
}

// Time Formatting
export function formatTime(ms) {
  if (!ms && ms !== 0) return '-';
  const totalSeconds = ms / 1000;
  
  if (totalSeconds >= 60) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = (totalSeconds % 60).toFixed(2);
    return `${minutes}:${seconds.padStart(5, '0')}`;
  }
  
  return totalSeconds.toFixed(2);
}

// Statistics Calculations
export function calculateStats(solves) {
  if (!solves || solves.length === 0) {
    return { mean: null, ao5: null, ao12: null, pb: null };
  }

  const validSolves = solves.filter(s => !s.dnf);
  if (validSolves.length === 0) {
    return { mean: null, ao5: null, ao12: null, pb: null };
  }

  const times = validSolves.map(s => s.time);
  const pb = Math.min(...times);
  const mean = times.reduce((a, b) => a + b, 0) / times.length;

  const ao5 = calculateAverage(times, 5);
  const ao12 = calculateAverage(times, 12);

  return { mean, ao5, ao12, pb };
}

function calculateAverage(times, n) {
  if (times.length < n) return null;
  
  const subset = times.slice(0, n);
  const sorted = [...subset].sort((a, b) => a - b);
  // Remove best and worst
  const trimmed = sorted.slice(1, -1);
  
  if (trimmed.length === 0) return null;
  return trimmed.reduce((a, b) => a + b, 0) / trimmed.length;
}

// Calculate best averages across all solves
export function calculateBestAverages(solves) {
  if (!solves || solves.length === 0) {
    return { pb: null, bestAo5: null, bestAo12: null };
  }

  const validSolves = solves.filter(s => !s.dnf);
  if (validSolves.length === 0) {
    return { pb: null, bestAo5: null, bestAo12: null };
  }

  const times = validSolves.map(s => s.time);
  const pb = Math.min(...times);

  // Calculate best Ao5
  let bestAo5 = null;
  if (times.length >= 5) {
    for (let i = 0; i <= times.length - 5; i++) {
      const ao5 = calculateAverage(times.slice(i), 5);
      if (ao5 !== null && (bestAo5 === null || ao5 < bestAo5)) {
        bestAo5 = ao5;
      }
    }
  }

  // Calculate best Ao12
  let bestAo12 = null;
  if (times.length >= 12) {
    for (let i = 0; i <= times.length - 12; i++) {
      const ao12 = calculateAverage(times.slice(i), 12);
      if (ao12 !== null && (bestAo12 === null || ao12 < bestAo12)) {
        bestAo12 = ao12;
      }
    }
  }

  return { pb, bestAo5, bestAo12 };
}
